import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

import { ButtonUI, DialogUI, FormLabelUI, SelectUI } from '../Interface';
import itemService from '../../service/item.service';
import addNotification from '../../utils/addNotification';
import { NotificationType } from '../../config';

const normalizeTemplateId = (id) => {
  if (id === undefined || id === null || id === '') {
    return '';
  }

  return String(id);
};

const ItemAttachmentPrintDialog = ({ open, onClose, itemCode, printTemplates = [] }) => {
  const [selectedTemplateId, setSelectedTemplateId] = useState('');

  useEffect(() => {
    if (!open) {
      return;
    }

    setSelectedTemplateId(normalizeTemplateId(printTemplates[0]?.id));
  }, [open, printTemplates]);

  const selectedTemplate =
    printTemplates.find((template) => normalizeTemplateId(template.id) === normalizeTemplateId(selectedTemplateId)) ??
    null;

  const templateOptions = printTemplates.map((template) => ({
    label: template.name,
    value: normalizeTemplateId(template.id),
  }));

  const handlePrint = async () => {
    if (!selectedTemplate?.id) {
      return addNotification({
        content: 'Nincs kiválasztott dokumentum sablon!',
        type: NotificationType.ERROR,
      });
    }

    if (!itemCode) {
      return addNotification({
        content: 'Nincs kiválasztott cikk!',
        type: NotificationType.ERROR,
      });
    }

    addNotification({
      content: 'Nyomtatás elindult!',
      type: NotificationType.INFO,
    });

    await itemService.printDocument({
      docId: itemCode,
      key: selectedTemplate.key,
      templateId: selectedTemplate.id,
    });
  };

  return (
    <DialogUI open={open} onClose={onClose} headerContent={'Cikk melléklet nyomtatás'} maxWidth="sm" fullWidth>
      <Box mt={1} p={1} display="flex" flexDirection="column" gap={2}>
        <SelectUI
          label={<FormLabelUI text="Dokumentum" />}
          option={templateOptions}
          value={selectedTemplateId}
          onChange={(e) => setSelectedTemplateId(e.target.value)}
        />

        <Typography variant="body2" color="text.secondary">
          {selectedTemplate?.name ?? ''}
        </Typography>
      </Box>

      <Box display="flex" justifyContent="center" gap="0.5rem" mt="1rem">
        <ButtonUI text="Nyomtatás" className="bg-success" onClick={handlePrint} disabled={!selectedTemplate?.id} />
        <ButtonUI text="Mégsem" className="bg-primary" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default ItemAttachmentPrintDialog;
